import React from 'react';
import ReactDOM from 'react-dom';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import AppContainer from './components/AppContainer';
import Start from './components/Start';
import TrackWrapper from './components/TrackWrapper';
import './index.css';
import './assets/styles/App.scss';

ReactDOM.render(
    <Router history={history}>
        <Route render={({ location }) => (
            <AppContainer>
                <Switch key={location.pathname}>
                    <Route path="/" exact={true} component={Start}/>
                    <Route path="/app/:reference/" component={TrackWrapper} addHandlerKey={true}/>
                </Switch>
            </AppContainer>
        )}/>
    </Router>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js